import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWegBrand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "70px",
	height: "48px",
	viewBox: "0 0 70 48",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "brand" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			id: "path-1",
			d: "M0.0146192893,0.183715736 L69.0676142,0.183715736 L69.0676142,47.9853807 L0.0146192893,47.9853807"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			"sketch:type": "MSPage",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Not\\xEDcia-Revista-(T13)---sem-revista",
				"sketch:type": "MSArtboardGroup",
				transform: "translate(-30.000000, -21.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "heander",
					"sketch:type": "MSLayerGroup",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "brand",
						transform: "translate(30.000000, 21.000000)",
						children: [
							/* @__PURE__ */ _jsx("g", { id: "Clip-2" }),
							/* @__PURE__ */ _jsx("path", {
								d: "M5.31338071,5.49612183 L5.31338071,32.0625381 L10.6257868,32.0625381 L10.6257868,10.8092589 L15.9384365,10.8092589 L15.9384365,32.0625381 L21.2523046,32.0625381 L21.2523046,10.8092589 L26.5654416,10.8092589 L26.5654416,37.3754315 L0,37.3754315 L0,0.183715736 L69.0676142,0.183715736 L69.0676142,5.49612183 L5.31338071,5.49612183",
								id: "Fill-1",
								fill: "#FEFFFF",
								"sketch:type": "MSShapeGroup",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M47.8182335,26.7476954 L47.8182335,10.8092589 L31.8778477,10.8092589 L31.8778477,37.3754315 L47.8172589,37.3754315 L47.8172589,32.0625381 L37.1912284,32.0625381 L37.1912284,26.7476954 L47.8182335,26.7476954 L47.8182335,26.7476954 Z M37.1912284,16.120934 L42.5050964,16.120934 L42.5050964,21.4350457 L37.1912284,21.4350457 L37.1912284,16.120934 Z",
								id: "Fill-3",
								fill: "#FEFFFF",
								"sketch:type": "MSShapeGroup",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M69.0676142,48 L69.0676142,10.8092589 L53.129665,10.8092589 L53.129665,37.3754315 L63.7559391,37.3754315 L63.7559391,42.6875939 L0,42.6875939 L0,48 L69.0676142,48 L69.0676142,48 Z M58.4430457,16.1233706 L63.7559391,16.1233706 L63.7559391,32.0625381 L58.4430457,32.0625381 L58.4430457,16.1233706 Z",
								id: "Fill-4",
								fill: "#FEFFFF",
								"sketch:type": "MSShapeGroup",
								mask: "url(#mask-2)"
							})
						]
					})
				})
			})
		})
	]
});
export default SvgWegBrand;
